import initMinigallery from './packages/package-minigallery';
import { initAccordions } from './utils';
import PriceFormatter from './utils/price-formatter';

window.com.parkside.zubehoer = function () {};

window.com.parkside.zubehoer.init = function () {
  initAccordions();
  initMinigallery();

  document.querySelectorAll('.acessory-proposal-button').forEach(button => {
    button.addEventListener('click', event => {
      event.preventDefault();
      const target = button.dataset.for;
      const amount = button.dataset.proposedAmount;
      const input = document.getElementById(target);
      input.value = amount;
      input.dispatchEvent(new Event('product-selection-changed'));
      const modalInputTargetId = `${button.dataset.modalFor}-${button.dataset.modalInputValue}`;
      document.getElementById(modalInputTargetId).checked = true;
    });
  });

  document.querySelectorAll('.open-product-button').forEach(button => {
    button.addEventListener('click', event => {
      const modalId = button.dataset.for;
      const selectedRadio = document.getElementById(modalId).querySelector('input[type="radio"]:checked');
      const selectedValue = selectedRadio ? selectedRadio.value : 'custom';
      event.preventDefault();
      jQuery.fancybox({
        content: jQuery('#' + modalId).html(),
        transitionIn: 'none',
        transitionOut: 'none',
        width: 'auto',
        height: 'auto',
        overlayShow: true,
        overlayOpacity: 0.9,
        overlayColor: '#474540',
        titleShow: false,
        padding: 20,
        margin: 0,
        hideOnOverlayClick: true,
        helpers: {
          overlay: {
            locked: true,
          },
        },
        onComplete: () => {
          jQuery.fancybox.center();

          function updateUserInputPrice() {
            const livePriceOutput = document.querySelector('#fancybox-content .product-modal-live-price');
            if (!livePriceOutput) {
              return;
            }
            const textInput = document.querySelector('#fancybox-content input[type="number"]');
            textInput.classList.remove('invalid');
            const userInput = Number.parseInt(textInput.value);
            if (userInput > 0) {
              const priceFormatter = new PriceFormatter(window.lang_code, window.currency_symbol);
              livePriceOutput.innerHTML = `
                  <span class="product-modal-price-suggest">
                    ${priceFormatter.format(textInput.dataset.price * userInput)}
                  </span>`;
            } else {
              livePriceOutput.innerHTML = '';
            }
          }

          // we have to do the updates, because fancybox duplicates the DOM - therefore we get duplicated IDs
          document.querySelectorAll('#fancybox-content label').forEach(label => {
            label.setAttribute('for', label.getAttribute('for') + '-modal');
          });
          document.querySelectorAll('#fancybox-content input[type="radio"]').forEach(radio => {
            radio.setAttribute('id', radio.getAttribute('id') + '-modal');
          });

          // select desired radio in the modal
          const input = document.querySelector('#fancybox-content input[type="radio"][value="' + selectedValue + '"]');
          input.checked = true;
          const textInput = document.querySelector('#fancybox-content input[type="number"]');
          if (selectedValue == 'custom') {
            updateUserInputPrice();
          } else {
            textInput.value = '';
          }

          if (document.querySelector('#fancybox-content input[type="radio"]:checked').value === 'custom') {
            textInput.focus();
          }
          textInput.addEventListener('click', () => {
            document.querySelector('#fancybox-content input[type="radio"][value="custom"]').checked = true;
          });
          textInput.addEventListener('keyup', () => {
            textInput.classList.remove('invalid');
            updateUserInputPrice();
          });
          // populate confirm button events
          const confirmButton = document.querySelector('#fancybox-content button.product-modal-button-select');
          confirmButton.addEventListener('click', e => {
            e.preventDefault();
            const currentRadioValue = document.querySelector('#fancybox-content input[type="radio"]:checked').value;
            let selectedValue = '';
            const target = confirmButton.dataset.for;
            const proposed = confirmButton.dataset.proposedAmount;
            switch (currentRadioValue) {
              case 'custom':
                const min = textInput.getAttribute('min') ?? 0;
                const max = textInput.getAttribute('max') ?? 1000;
                selectedValue = Number.parseInt(textInput.value);
                document.getElementById(`${confirmButton.dataset.modalFor}-custom`).checked = true;
                if (!selectedValue || selectedValue < min || selectedValue > max) {
                  textInput.classList.add('invalid');
                  return;
                }
                break;
              case 'recommended':
                selectedValue = Number.parseInt(proposed);
                document.getElementById(`${confirmButton.dataset.modalFor}-recommended`).checked = true;
                break;
              case 'none':
                document.getElementById(`${confirmButton.dataset.modalFor}-none`).checked = true;
                break;
            }
            const input = document.getElementById(target);
            input.value = selectedValue;
            input.dispatchEvent(new Event('product-selection-changed'));
            jQuery.fancybox.close();
          });
          // populate cancel button events
          document
            .querySelector('#fancybox-content button.product-modal-button-cancel')
            .addEventListener('click', e => {
              e.preventDefault();
              jQuery.fancybox.close();
            });
        },
        // onStart, onClosed - project specific approach to center the fancybox on screen
        onStart: function () {
          jQuery('body').css({ overflow: 'hidden' });
          if (jQuery('#fancybox-wrap').parent('.fancybox-wrap-no-scroll').length <= 0) {
            jQuery('#fancybox-wrap').wrap("<div class='fancybox-wrap-no-scroll'></div>");
          }
          jQuery('#fancybox-close').append('<span class="fa fa-times fa-lg"></span>');
        },
        onClosed: function () {
          if (jQuery('#fancybox-wrap').parent('.fancybox-wrap-no-scroll').length) {
            jQuery('#fancybox-wrap').unwrap();
          }
          jQuery('body').css({ overflow: '' });
        },
      });
    });
  });

  document.querySelectorAll('.product-input-field').forEach(input => {
    if (input.value) {
      updateOutletsByInput(input);
    }

    input.addEventListener('product-selection-changed', event => {
      event.preventDefault();
      updateOutletsByInput(input);
    });
  });

  document.querySelectorAll('.product-remove-amount').forEach(button => {
    button.addEventListener('click', event => {
      event.preventDefault();
      const target = button.dataset.for;
      const input = document.getElementById(target);
      input.value = '';
      input.dispatchEvent(new Event('product-selection-changed'));
      const modalInputTargetId = `${button.dataset.modalFor}-${button.dataset.modalInputValue}`;
      document.getElementById(modalInputTargetId).checked = true;
    });
  });
};

function updateOutletsByInput(input) {
  const priceFormatter = new PriceFormatter(window.lang_code, window.currency_symbol);
  const targetAmount = input.dataset.amountFor;
  const targetPrice = input.dataset.priceFor;
  const targetAmountInput = input.dataset.amountValueFor;
  const amount = input.value;
  const price = priceFormatter.format(input.dataset.price * amount);
  document.querySelectorAll(targetAmount).forEach(outlet => (outlet.innerHTML = amount));
  document.querySelectorAll(targetPrice).forEach(outlet => (outlet.innerHTML = price));
  document.querySelectorAll(targetAmountInput).forEach(input => input.setAttribute('value', amount));
}
